import React from 'react';
import './BottomNav.css';

const items = [
  { id: 'home', label: 'Início', icon: '⌂' },
  { id: 'scan', label: 'Scan', icon: '◎' },
  { id: 'history', label: 'Histórico', icon: '◷' },
];

export default function BottomNav({ active, onChange }) {
  return (
    <nav className="bottom-nav">
      {items.map(item => (
        <button
          key={item.id}
          className={`nav-item ${active === item.id ? 'active' : ''}`}
          onClick={() => onChange(item.id)}
        >
          <span className="nav-icon">{item.icon}</span>
          <span className="nav-label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
